
import { isTimeRangeValid } from '@bingads-webui-campaign/segmentation-utilities';
import _ from 'underscore';
import Promise from 'bluebird';

export const getFetchPreferenceConfig =
  ({ state, preferencesService, segmentationPreferences }) => {
    if (!state || !preferencesService || !segmentationPreferences) {
      return {};
    }
    const { getSegPreference, getSegType } = segmentationPreferences;
    return {
      fetchPreferenceConfig: (gridConfig) => {
        const defaultPageSize = 20;
        const sortInfoKey = gridConfig.name;

        const p$stateManager = new Promise((resolve) => {
          preferencesService.default.initialize().then(() => {
            const { Data: { rowsPerPage: pageSize = defaultPageSize } } = preferencesService.default.findByName('WebApp.CampaignUI.grid') || { Data: {} };
            const { Data: { sortInfo: { orderby: orderbyInfo, sortableHeader } } } =
              preferencesService.default.findByName(`WebApp.CampaignUI.${sortInfoKey}`) || { Data: { sortInfo: {} } };

            resolve({ pageSize, orderbyInfo, sortableHeader });
          });
        });

        return Promise
          .all([p$stateManager, getSegPreference(gridConfig.name)])
          .spread(({ pageSize, orderbyInfo, sortableHeader }) => {
            gridConfig = _.defaults(gridConfig, {pageable: {}});  //eslint-disable-line
            gridConfig.pageable.pageSize = pageSize; //eslint-disable-line
            if (gridConfig.plugins && gridConfig.plugins.pagination) {
              gridConfig.plugins.pagination.pageSize = pageSize; //eslint-disable-line
            }
            if (gridConfig.plugins &&
            gridConfig.plugins.pagination &&
            gridConfig.plugins.pagination.pageSize) {
              gridConfig.plugins.pagination.pageSize = pageSize; //eslint-disable-line
            }

            const segType = getSegType(gridConfig.name);

            if (segType && segType.segmentationType !== 'None' && isTimeRangeValid(segType.segmentationType, state.get('$daterange'))) {
              gridConfig.dataSource.query.SegmentationTypes = segType.segmentationType; //eslint-disable-line
            }

            if (orderbyInfo && orderbyInfo.length > 0) {
              gridConfig.dataSource.orderby = orderbyInfo; //eslint-disable-line
              gridConfig.sortableHeader = _.pick(sortableHeader, 'name', 'directionIndex'); //eslint-disable-line
            }
          });
      },
    };
  };
